import { createRouter, createWebHistory } from 'vue-router';
import { middlewareLayout } from './middleware';

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'Home',
			component: () => import('@/views/Home.vue'),
			meta: {
				layout: 'Default',
			},
		},
		{
			path: '/register',
			name: 'Register',
			component: () => import('@/views/Register.vue'),
			meta: {
				layout: 'Empty',
			},
		},
		{
			path: '/login',
			name: 'CommitteeLogin',
			component: () => import('@/views/CommitteeLogin.vue'),
			meta: {
				layout: 'Empty',
			},
		},
		{
			path: '/committee',
			name: 'CommitteeHome',
			component: () => import('@/views/CommitteeHome.vue'),
			meta: {
				layout: 'CommitteeHome',
			},
		},
		{
			path: '/privacy-policy',
			name: 'PrivacyPolicy',
			component: () => import('@/views/PrivacyPolicy.vue'),
			meta: {
				layout: 'NoLogout',
			},
		},
		{
			path: '/terms-and-conditions',
			name: 'TermsAndConditions',
			component: () => import('@/views/TermsAndConditions.vue'),
			meta: {
				layout: 'NoLogout',
			},
		},
		{
			path: '/:pathMatch(.*)*',
			name: 'NotFound',
			component: () => import('@/views/NotFound.vue'),
			meta: {
				layout: 'Empty',
			},
		},
	],
});

router.beforeEach(middlewareLayout);
router.afterEach(() => {
	setTimeout(() => {
		if (window) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}, 200);
});

export default router;
